import "./edit-profile.scss";

import { useApp, useModal } from "providers";
import { uploadImage } from "utils/upload";
import { NotePencil, X } from "@phosphor-icons/react";
import { useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import { userType } from "types/user.type";
import { updateUserProfile } from "utils/axios";

const EditProfileModal = () => {
  const { closeModal } = useModal();
  const { user, setUser } = useApp()

  const [bio, setBio] = useState("");
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const bioRef = useRef<HTMLTextAreaElement | null>(null);
  const usernameRef = useRef<HTMLInputElement | null>(null);
  const imageRef = useRef<HTMLInputElement | null>(null);
  const [preview, setPreview] = useState<string | undefined>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const onSelectFile = (e: any) => {
    if (!e.target.files || e.target.files.length === 0) return;
    setSelectedFile(e.target.files[0]);
  };
  useEffect(() => {
    setUsername(user.name);
    setBio(user.bio);
  }, [user])

  useEffect(() => {
    if (!selectedFile) return;
    const objectUrl = URL.createObjectURL(selectedFile as Blob);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const updateProfile = async () => {
    if (username == "") return;
    setLoading(true);

    try {
      const imageUrl = !selectedFile ? user.avatar : await uploadImage(selectedFile);

      if (!imageUrl) {
        return;
      }
      const updateUser: userType = {
        name: username,
        avatar: imageUrl,
        wallet: user.wallet,
        followers: user.followers,
        following: user.following,
        bio: bio == "" ? user.bio : bio,
      }

      const res = await updateUserProfile(updateUser);
      if (res) {
        setUser(updateUser);
      }

    } catch (error) {
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  return (
    <div className="bg-[#010409] base-modal edit-profile">
      <div className="base-modal__header">
        <div className="base-modal__header--title">
          <div className="close-btn" onClick={() => closeModal()}>
            <X size={20} weight="regular" />
          </div>

          <div className="base-modal__header--title__inner">
            <p className="font-semibold text-white text-lg">Edit profile</p>
          </div>
        </div>

        <button
          className="save-btn"
          disabled={!username || !bio}
          data-disabled={!username || !bio}
          onClick={updateProfile}
        >
          <p className="font-semibold text-sm">Save</p>
          {loading && (
            <ClipLoader
              size={12}
              color={"#444"}
              loading={loading}
              aria-label="Loading Spinner"
            />
          )}
        </button>
      </div>

      <div className="base-modal__body">
        <div className="c-img-input">
          <div
            className="c-img-input__preview"
            onClick={() => {
              if (imageRef.current) {
                imageRef.current.click();
              }
            }}
          >
            <img alt="" src={preview || user.avatar} />
            <input
              type="file"
              ref={imageRef}
              accept="image/*"
              multiple={false}
              name="ramp-fun-[image]"
              onChange={onSelectFile}
              className="image-file-input"
            />

            <button className="add-image-btn">
              <NotePencil size={22} weight="regular" />
            </button>
          </div>
        </div>

        <div
          className="flex flex-col gap-1 p-2 border-[1px] border-white/20 rounded-md w-full"
          onClick={() => {
            if (usernameRef.current) usernameRef.current.focus();
          }}
        >
          <label className="flex flex-row justify-between items-center py-1 text-white/40">
            <p className="font-semibold text-sm label">Username</p>
            <p className="font-semibold text-sm">{username?.length || 0}/12</p>
          </label>
          <input
            maxLength={12}
            value={username}
            ref={usernameRef}
            className="bg-transparent px-1 py-1 w-full font-medium text-white text-base"
            placeholder="Pepe"
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div
          className="flex flex-col gap-1 p-2 border-[1px] border-white/20 rounded-md w-full"
          onClick={() => {
            if (bioRef.current) bioRef.current.focus();
          }}
        >
          <label className="flex flex-row justify-between items-center py-1 text-white/40">
            <p className="font-semibold text-sm label">Bio</p>
            <p className="font-semibold text-sm">{bio?.length || 0}/250</p>
          </label>
          <textarea
            className="bg-transparent px-1 py-1 w-full font-medium text-white text-base"
            value={bio}
            ref={bioRef}
            maxLength={250}
            placeholder="WAGMI!"
            onChange={(e) => setBio(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default EditProfileModal;
